import React, { Component } from 'react';
import {
  
} from "react-router-dom";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from '../../constant/Utils';
import Header from '../common/Header';
import Footer from '../common/Footer';

import { getAccount, updateAccount, CMS_BASE_URL } from '../../redux/action';

import './home.css'; 
import '../common/common.css'; 

import accountBanner from '../../images/accountBanner.png';

class Account extends Component {

	constructor(props, context) {
	    super(props, context);
	    this.state = {
	    	title: "My Account",
	    	name: "",
	    	reg_number: "",
	    	email: "",
	    	password: "",
	    	cpw: "",
	    	s_code: "",
	    	checked: false,
	    	errorName: false,
	    	errorNumber: false,
	    	errorEmail: false,
	    	errorPw: false,
	    	errorCpw: false,
	    	errorCode: false,
	    	errorCheck: false,
	    	errorGeneral: false,
	    	underReview: false,
	    	userInfo: {}
	    };
    }

	componentWillMount() {
		let token = window.localStorage.getItem("token");
		if (token) {
			getAccount({ "token": token }).then(res => {
				this.setState({ name: res.data.user.name, reg_number: res.data.user.medical_council_registration_umber, email: res.data.user.email });
			}, this);
		} else {
			window.location.href = "/login";
		}
		
	}

	validateReg() {
		if (this.state.name == "") {
			this.setState({ errorName: true })
			return
		} else {
			this.setState({ errorName: false })
		}

		// if (this.state.reg_number == "") {
		// 	this.setState({ errorNumber: true })
		// 	return
		// } else {
		// 	this.setState({ errorNumber: false })
		// }

		// let emailVal = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

		// if (this.state.email == "" || !emailVal.test(this.state.email)) {
		// 	this.setState({ errorEmail: true })
		// 	return
		// } else {
		// 	this.setState({ errorEmail: false })
		// }

		if (this.state.password == "" || !/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/.test(this.state.password)) {
			this.setState({ errorPw: true })
			return
		} else {
			this.setState({ errorPw: false })
		}

		if (this.state.password != this.state.cpw) {
			this.setState({ errorCpw: true })
			return
		} else {
			this.setState({ errorCpw: false })
		}

		if (!this.state.checked) {
			this.setState({ errorCheck: true })
			return
		} else {
			this.setState({ errorCheck: false })
		}

		this.updateUser();
	}

	updateUser() {
		let token = window.localStorage.getItem("token");
		if (token) {
			updateAccount({ "token": token, "username": this.state.name,"password": this.state.password }).then(res => {
						if (res.data.code == 200) {
							window.location.href = "/account";
						}

						if (res.data.code == 402) {
							this.setState({ errorGeneral: true });
						}
			}, this);
		}
	}

	logout() {
		let token = window.localStorage.removeItem("token");
		window.location.href = "/login";
	}


	render() {

		return(
			<div className="geContainer">
				<Header urlKey={this.props.urlKey} />
				<div className="mainContainer">
					<img className="banner" src={accountBanner} />
					<div className="sectionContainer">
						<div className="headline containerMaxWidth">
							<h2>{ this.state.title }</h2>
						</div>
						<div className="bodyContent containerMaxWidth memberContainer registerContainer">
							<div className="searchResultSeparator">
								<p className="subHeader">Personal information</p>
							</div>
							
							<div className="inputBox">
								<span>Name: </span>
								<input className="fieldInput" type="text" onChange={(e) => this.setState({ name: e.target.value }) } value={this.state.name} />
								<p className={this.state.errorName ? "errorRemark active" : "errorRemark"}>Please fill in your name</p>
							</div>
							<div className="inputBox">
								<span>Medical Council Registration Number: </span>
								<input className="fieldInput" type="text" disabled onChange={(e) => this.setState({ reg_number: e.target.value }) } value={this.state.reg_number} />
								<p className={this.state.errorNumber ? "errorRemark active" : "errorRemark"}>Please fill in your Medical Council Registration Number</p>
							</div>
							<div className="inputBox">
								<span>Email Address: </span>
								<input className="fieldInput" type="email" disabled onChange={(e) => this.setState({ email: e.target.value }) } value={this.state.email} />
								<p className={this.state.errorEmail ? "errorRemark active" : "errorRemark"}>Please fill in a valid email address</p>
							</div>
							<div className="inputBox">
								<span>New Password: </span>
								<input className="fieldInput" type="password" onChange={(e) => this.setState({ password: e.target.value }) } />
								<p className={this.state.errorPw ? "errorRemark active" : "errorRemark"}>Please fill in your password</p>
							</div>
							<div className="inputBox">
								<span>Confirmed Password: </span>
								<input className="fieldInput" type="password" onChange={(e) => this.setState({ cpw: e.target.value }) } />
								<p className={this.state.errorCpw ? "errorRemark active" : "errorRemark"}>Password does not match </p>
							</div>
							<div className="inputBox">
								<span>Security Code: </span>
								<input className="fieldInput" type="text" />
								<p className="errorRemark"></p>
							</div> 
							<div className="tncInput inputBox">
								<input type="checkbox" onChange={() => this.setState({ checked: !this.state.checked })} />
								<span>I confirm that I have read and agree to the <a href="https://www.azprivacy.astrazeneca.com/asia-pacific/hongkong/en/privacy-notices.html#accordion-list-item-75b4bb02e1" target="_blank" rel="noopener">Astrazeneca's privacy policy</a> and <a target="_blank" href="https://www.daiichisankyo.com.hk/Privacy/">Daiichisankyo's privacy policy</a></span>
								<p className={this.state.errorCheck ? "errorRemark active" : "errorRemark"}>Please confirm your read the Terms and Conditions</p>
							</div>

							<div>
								<div className="buttonBox" onClick={() => this.validateReg()}>
									<div className="memberBtn actionBtn">
										<a><span>UPDATE</span></a>
									</div>
									<div className="memberBtn resetBtn actionBtn" onClick={() => this.logout()}>
										<a href="/"><span>LOGOUT</span></a>
									</div>
								</div>
								<p style={{ textAlign: 'center', position: 'relative' }} className={this.state.errorGeneral ? "errorRemark active" : "errorRemark"}>Email address is already registered</p>
							</div>

						</div>
						
					</div>
				</div>
				<Footer urlKey={this.props.urlKey} />
			</div>
		);
	}

}

const mapStateToProps = (state) => {
  return {

  };
}

const mapDispatchToProps = dispatch => bindActionCreators({

}, dispatch)

export default withRouter(connect(
  mapStateToProps,
  {  }
)(Account));